export const GetG2APISurveyFormEmbedUrl = (
    baseUrl: string,
    stateToken: string,
    email: string
) => {
    return `${baseUrl}/users/login.embed?state=${stateToken}&email=${encodeURIComponent(
        email
    )}`;
};
